import './styles/FileSelector.scss';
import { useState, useRef, useEffect } from 'react';

//classes
import IFile from '../i-classes/ifile.tsx';

//muis
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CancelIcon from '@mui/icons-material/Cancel';

const nonstate = {
    defaultAllowedFiles: "application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
}

interface Props {
    files: IFile[], SetFiles: any
    allowedFiles?: string,
    fileSizeLimit?: number //in MB
}

const FileSelector: React.FC<Props> = ({ files, SetFiles, allowedFiles, fileSizeLimit }) => {

    //refs
    const fileInputRef = useRef<any>(null);

    //ui functions
    const OnSelectFileClicked = () => {
        fileInputRef.current.click();
    }
    const OnFileInputChanged = (inFiles: any[]) => {
        let _inFiles = [] as any[];
        //check filesize in control
        let sizeLimitExceeds = false;
        Object.keys(inFiles).map((key: any) => {
            const file = inFiles[key];

            if (fileSizeLimit != undefined) {
                if (file.size < (fileSizeLimit * 1024 * 1024)) //MB to bytes
                {
                    _inFiles.push(file);
                } else {
                    sizeLimitExceeds = true;
                }
            } else {
                _inFiles.push(file);
            }
        });

        if (sizeLimitExceeds)
            alert('You are not able to upload file size greater than ' + fileSizeLimit + 'MB.');

        //append and export files outside container
        const iFiles = files;
        _inFiles.map((file: any) => {
            iFiles.push(new IFile(file, file.name));
        });
        SetFiles([...iFiles]);
    }
    const OnRemoveFileClicked = (index: number) => {
        const _files = files;
        _files.splice(index, 1);
        SetFiles([..._files]);
    }

    //exe functions
    const UpdateFileLabel = (index: number, newLabel: string) => {
        const targetFile = files[index];
        targetFile.SetLabel(newLabel);

        const _files = files;
        _files.splice(index, 1, targetFile);
        SetFiles([..._files]);
    }

    //render functions
    const RenderFiles = () => {
        return files.map((file: IFile, i: number) => {
            return (
                <div className='FileSelector-file-block'>
                    <input className='FileSelector-file-block-in' value={file.label} onChange={(e: any) => UpdateFileLabel(i, e.target.value)} onFocus={(e: any) => {e.target.select()}}/>
                    <button className='FileSelector-file-block-btn' onClick={() => OnRemoveFileClicked(i)}><CancelIcon /></button>
                </div>
            )
        });
    }

    return (
        <div className='FileSelector'>
            <button className='FileSelector-select-btn' onClick={() => OnSelectFileClicked()}>
                <CloudUploadIcon />Select Files
                <input ref={fileInputRef} type="file" multiple accept={allowedFiles ? allowedFiles : nonstate.defaultAllowedFiles} hidden onChange={(e: any) => OnFileInputChanged(e.target.files)} />
            </button>
            <div className='FileSelector-scroll'>
                {
                    files.length > 0 ?
                        RenderFiles()
                        :
                        null
                }
            </div>
        </div>
    );
}
export default FileSelector;